export const instantAccessItems: string[] = [
  'Tutti i 6 volumi completi in PDF, scaricabili subito dopo il pagamento',
  '120 schede esercizio illustrate, una per ogni movimento del repertorio',
  'Piani di lezione già pronti da 50 minuti per ogni livello',
  'Progressioni base, intermedie e avanzate per adattare ogni sequenza',
  'Indicazioni su regolazione del carrello e tensione delle molle',
  'Poster e materiali da stampare per la sala e per le allieve',
  'Accesso permanente ai file e a tutti gli aggiornamenti futuri',
]
